module.exports = __webpack_public_path__ + "img/slot-machine.f74ee7ed.svg";